/*
 * @Author: your name
 * @Date: 2020-07-16 10:02:50
 * @LastEditTime: 2020-08-10 14:33:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qixin_admine:\JavaProjects\Projects\kangyi\web\kangyi_vue\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'layOut',
      component: () => import('@/components/navBar/navBar'),
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'index',
          component: () => import('@/views/index/index'),
          meta: {
            title: '首页 | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('@/views/about/index'),
          meta: {
            title: '关于企业 | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
        {
          path: '/oem',
          name: 'oem',
          component: () => import('@/views/oem/index'),
          meta: {
            title: 'OEM/ODM | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
        {
          path: '/infocenter',
          name: 'infocenter',
          component: () => import('@/views/infocenter/index'),
          meta: {
            title: '资讯中心 | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
        {
          path: '/product',
          name: 'product',
          component: () => import('@/views/product/index'),
          meta: {
            title: '品牌中心 | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
        {
          path: '/brand_details',
          name: '品牌列表',
          component: () => import('@/views/product/brandDetail/index'),
          meta: {
            title: '品牌中心 | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
        {
          path: '/details',
          name: '品牌详情',
          component: () => import('@/views/product/detail/index'),
          meta: {
            title: '品牌中心 | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
        {
          path: '/contact',
          name: 'contact',
          component: () => import('@/views/contact/index'),
          meta: {
            title: '联系我们 | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
        {
          path: '/article_details',
          name: '文章详情',
          component: () => import('@/views/infocenter/details/index'),
          meta: {
            title: '文章详情 | 广东康怡卫生用品有限公司'
          },
          hidden: true
        },
      ]
    },
    {
      path: '/404',
      component: () => import('@/views/404'),
      hidden: true
    },
    {
      path: '/designAbout',
      component: () => import('@/views/design/index'),
      hidden: true
    },
    {
      path: '/designOem',
      component: () => import('@/views/design/index2'),
      hidden: true
    },
    {
      path: '*',
      redirect: '/404',
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js